var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.541 6.81642C15.541 5.27381 14.9282 3.79438 13.8375 2.70359C12.7467 1.6128 11.2672 1 9.72463 1C8.18202 1 6.70259 1.6128 5.6118 2.70359C4.52101 3.79438 3.90821 5.27381 3.90821 6.81642C3.90821 13.6022 1 15.541 1 15.541H18.4493C18.4493 15.541 15.541 13.6022 15.541 6.81642Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4015 18.0342C11.2311 18.328 10.9864 18.5719 10.6921 18.7414C10.3978 18.9109 10.0641 19.0001 9.72443 19.0001C9.38477 19.0001 9.05107 18.9109 8.75675 18.7414C8.46242 18.5719 8.21779 18.328 8.04736 18.0342",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.b9e135600601a6bc824e39cbdaeaf1e9.svg";
export { ForwardRef as ReactComponent };